import app from 'flarum/forum/app';
import addGlossaryTermsSetting from './addGlossaryTermsSetting';
import addOthersMenu from './addOthersMenu';
import addPrivateMessagesHeaderLink from './addPrivateMessagesHeaderLink';
import glossaryTerms from './glossaryTerms';
import refreshListAfterPrivateDiscussions from './refreshListAfterPrivateDiscussions';
export { default as extend } from './extend';
app.initializers.add('champis-others', () => {
  addOthersMenu();
  addPrivateMessagesHeaderLink();
  refreshListAfterPrivateDiscussions();
  glossaryTerms();
  addGlossaryTermsSetting();
});